import { useRouteMatch } from "react-router-dom";
import useGetApprover from "../hooks/useGetApprovers";
import { Loader } from "../../../../../../../UI/Loaders/Loaders";
import { ApiErrorState } from "../../../../../../../interfaces/response";

const SignatoryApprovals = () => {
  const match = useRouteMatch();
  const { id } = match.params as { id: number };

  const {
    data: noOfApprovers,
    isLoading,
    isError,
    error,
  } = useGetApprover({ customerId: Number(id) });

  let RenderedComponent = null;

  if (isLoading) {
    RenderedComponent = <Loader centered={true} text="Fetching approvals..." />;
  } else if (isError) {
    RenderedComponent = (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt p-y-5">
            <i className="fas fa-bell" />{" "}
            {(error as ApiErrorState)?.response?.data?.message ||
              "An error occurred"}{" "}
          </h4>
        </div>
      </div>
    );
  } else if (!noOfApprovers?.data) {
    RenderedComponent = (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt">
            <i className="fas fa-bell" /> No signatory information available
          </h4>
        </div>
      </div>
    );
  } else {
    // Display the signatory information
    const numberOfSignatories = noOfApprovers?.data?.numberOfSignatories;
    const status = noOfApprovers?.data?.status || "";

    return (
      <div className="container-fluid" style={{ maxWidth: "900px" }}>
        <div
          className="card border-0"
          style={{ borderRadius: "12px", overflow: "hidden" }}
        >
          {/* Header Section */}
          <div
            className="card-header bg-white border-0 d-flex align-items-center"
            style={{ padding: "1.5rem", borderBottom: "1px solid #e9ecef" }}
          >
            <i
              className="fas fa-users-cog mr-2"
              style={{ color: "#713fff", fontSize: "1.25rem" }}
            ></i>
            <h5
              className="mb-0"
              style={{ color: "#150849", fontWeight: "600" }}
            >
              Signatory Approvals
            </h5>
          </div>

          {/* Content Section */}
          <div className="card-body bg-white" style={{ padding: "2rem" }}>
            <div className="row">
              {/* Number of Signatories Card */}
              <div className="col-md-6 mb-3 mb-md-0">
                <div
                  className="border rounded p-4"
                  style={{ borderColor: "#e9ecef", height: "100%" }}
                >
                  <p
                    className="text-muted text-uppercase mb-3"
                    style={{
                      fontSize: "0.75rem",
                      fontWeight: "600",
                      letterSpacing: "0.1em",
                    }}
                  >
                    Number of Approvers
                  </p>
                  {numberOfSignatories === null ||
                  numberOfSignatories === undefined ? (
                    <div>
                      <h5
                        className="font-weight-bold mb-2"
                        style={{ color: "#150849" }}
                      >
                        Signatory Setup Not Configured
                      </h5>
                      <p
                        className="text-muted mb-0"
                        style={{ fontSize: "0.875rem" }}
                      >
                        This business account has not set up signatory approvals
                        yet.
                      </p>
                    </div>
                  ) : numberOfSignatories === 0 ? (
                    <div>
                      <h5
                        className="font-weight-bold mb-2"
                        style={{ color: "#150849" }}
                      >
                        No Second Level Approval Required
                      </h5>
                      <p
                        className="text-muted mb-0"
                        style={{ fontSize: "0.875rem" }}
                      >
                        This business account does not require additional
                        signatory approvals.
                      </p>
                    </div>
                  ) : (
                    <div className="d-flex align-items-baseline">
                      <span
                        className="font-weight-bold"
                        style={{
                          fontSize: "3.5rem",
                          lineHeight: "1",
                          color: "#713fff",
                        }}
                      >
                        {numberOfSignatories}
                      </span>
                      <span
                        className="ml-2"
                        style={{
                          fontSize: "1rem",
                          fontWeight: "500",
                          color: "#645e77",
                        }}
                      >
                        {numberOfSignatories === 1
                          ? "Signatory"
                          : "Signatories"}
                      </span>
                    </div>
                  )}
                </div>
              </div>

              {/* Status Card - Always display */}
              <div className="col-md-6">
                <div
                  className="border rounded p-4"
                  style={{ borderColor: "#e9ecef", height: "100%" }}
                >
                  <p
                    className="text-muted text-uppercase mb-3"
                    style={{
                      fontSize: "0.75rem",
                      fontWeight: "600",
                      letterSpacing: "0.1em",
                    }}
                  >
                    Approval Status
                  </p>
                  <p
                    className="mb-0"
                    style={{
                      fontSize: "0.9375rem",
                      color: "#150849",
                      lineHeight: "1.6",
                      wordBreak: "break-word",
                    }}
                  >
                    {status || "No status available"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <div>{RenderedComponent}</div>;
};

export default SignatoryApprovals;
